import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { IntegrationEventLog, IntegrationEventLogCreate, IntegrationEventLogFilter } from '../data/integrationEventLog';

export function createIntegrationEventLogService(client: AxiosInstance) {
  return createCrudService<IntegrationEventLog, IntegrationEventLogCreate, IntegrationEventLogFilter>(
    client,
    '/integration/IntegrationEventLog',
    'id',
  );
}

export type IntegrationEventLogService = CrudService<IntegrationEventLog, IntegrationEventLogCreate, IntegrationEventLogFilter>;
